<template>
  <footer class="main-footer-container">
    <div class="main-footer-container__top">
      <div class="footer-col footer-col-1-info">
        <img src="@/assets/logo.png" alt="m2VET" class="main-footer-logo">
        <p v-html="footerFirstCol.text"></p>
        <div class="footer-find-social" v-if="filteredSocials.length">
          <a :href="social.url" v-for="social in filteredSocials" :key="social.id" target="_blank" rel="noopener noreferrer">
            <button><img :src="social.icon_url" :alt="social.name"></button>
          </a>
        </div>
      </div>
      <div class="footer-col footer-col-2-nav">
        <strong>Nawigator</strong>
        <RouterLink to="/">Strona główna</RouterLink>
        <RouterLink to="/announcements">Ogłoszenia</RouterLink>
        <RouterLink to="/blog">Blog</RouterLink>
        <RouterLink to="/kontakt">Kontakt</RouterLink>
<!--        <a href="http://warsztaty.m2vet.pl" target="_blank" rel="noopener noreferrer">Szkolenia</a>-->
      </div>
      <div class="footer-col footer-col-3-legal">
        <strong>Informacje prawne</strong>
        <RouterLink to="/statute">Regulamin</RouterLink>
        <RouterLink to="/privacy">Polityka prywatności</RouterLink>
        <RouterLink to="/cookies">Polityka plików cookie</RouterLink>
      </div>
      <div class="footer-col footer-col-4-con">
        <strong>Kontakt</strong>
        <span>Obsługa klienta</span>
        <span>tel: {{ footerThirdCol.telNum }}</span>
        <span>email: {{ footerThirdCol.email }}</span>
        <span>{{ footerThirdCol.address1 }}</span>
        <span>{{ footerThirdCol.address2 }}</span>
        <ButtonVue
            v-if="isBiz"
            :text="isBiz=='true' ? 'dla usługobiorcy' : 'dla biznesu'"
            bgColor="#f97316"
            color="#fff"
            @click="() => {
            $emit('toggleBlur')
            appStore.setIsBusiness(isBiz)
          }"
        />
      </div>
    </div>
    <div class="main-footer-container__bottom">
      <span v-html="footerFirstCol.copyright"></span>
      <span>Strona do prawidłowego działania wymaga plików cookies.</span>
    </div>
  </footer>
</template>

<script>
import axios from 'axios';
import ButtonVue from './Button.vue';
import { useRoute } from 'vue-router';
import { useAppStore } from '@/stores/app';

export default{
  name:"FooterVue",
  setup() {
    return {
      appStore: useAppStore(),
    }
  },
  data(){
    return{
      footerFirstCol:{
        copyright: '&copy; m2VET sp. z.o.o. Wszelkie prawa zastrzeżone',
        logo_url: '',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla ex ipsum, tempor id turpis a, consectetur scelerisque lacus. Suspendisse tempus, quam et interdum facilisis, enim arcu convallis eros, ut rutrum.'
      },
      footerSecondCol:[
        {
          name: 'facebook',
          icon_url: '',
          url: 'https://facebook.com'
        },
        {
          name: 'instagram',
          icon_url: '',
          url: 'https://instagram.com'
        }
      ],
      footerThirdCol:{
        telNum: 'brak',
        email: 'brak',
        address1: 'brak',
        address2: 'brak'
      }
    }
  },
  mounted(){
    this.getFooterData()
  },
  components:{
    ButtonVue
  },
  computed:{
    isBiz(){
      if(useRoute()?.fullPath == '/'){
        return 'false'
      }else if(useRoute()?.fullPath?.includes('/dla-biznesu') ?? false){
        return 'true'
      }else{
        return false
      }
    },
    filteredSocials() {
      return (this.footerSecondCol || []).filter((social) => {
        return Boolean(social && social.icon_url && social.url)
      })
    }
  },
  methods:{
    getFooterData(){
      const ob = {
        page: 1,
        limit: 50
      }

      axios.get(`/FooterSettingsGet`)
          .then(res => {
            this.footerFirstCol = res.data
          })

      axios.post(`/SocialIconSearch`, ob)
          .then(res => {
            this.footerSecondCol = res.data.items
          })

      axios.get(`/ContactGet`)
          .then(res => {
            this.footerThirdCol.telNum = res.data.phone
            this.footerThirdCol.email = res.data.email
            this.footerThirdCol.address1 = res.data.address_1
            this.footerThirdCol.address2 = res.data.address_2
          })
    },
    scrollSiteUp(){
      window.scrollTo(0,0)
    }
  }
}
</script>

<style scoped>
.main-footer-container{
  background: #1f2937;
  color: #d1d5db;
}
.main-footer-container__top{
  width: min(1200px, calc(100% - 32px));
  margin: 0 auto;
  padding: 44px 0 28px;
  display: grid;
  grid-template-columns: 1.3fr 1fr 1fr 1fr;
  gap: 24px;
}
.footer-col{
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 1.4rem;
}
.footer-col strong{
  color: #fff;
  margin-bottom: 6px;
}
.main-footer-logo{
  width: 140px;
  margin-bottom: 8px;
}
.footer-col a{
  color: #d1d5db;
  text-decoration: none;
}
.footer-col a:hover{
  color: #fff;
}
.footer-find-social{
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.footer-find-social > a > button{
  border: 1px solid #374151;
  background: #111827;
  border-radius: 8px;
  padding: 6px 8px;
  cursor: pointer;
}
.footer-find-social > a > button > img{
  width: 18px;
}
.main-footer-container__bottom{
  width: min(1200px, calc(100% - 32px));
  margin: 0 auto;
  padding: 18px 0 24px;
  border-top: 1px solid #374151;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #9ca3af;
  font-size: 1.2rem;
}
@media (max-width: 980px){
  .main-footer-container__top{
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 640px){
  .main-footer-container__top{
    grid-template-columns: 1fr;
  }
  .main-footer-container__bottom{
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>